import { Outlet } from 'react-router-dom'

const MyQuizTemplatesWrapper = () => {
  return <Outlet />
}

export default MyQuizTemplatesWrapper
